import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  Modal,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { ReactSortable } from "react-sortablejs";
import { Typeahead } from "react-bootstrap-typeahead";
import { getSurveyTemplates, onAddSurveyTemplate } from "../../../redux/survey/surver_template/actions";

import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import {
  getWorkflowBlockCheckLists,
  saveWorkflowBlockCheckList,
  editWorkflowBlockCheckList,
  deleteWorkflowBlockCheckList,
  saveWorkFlowBlockCheckListPosition,
  estadoActividad,
} from "../../../redux/on&offBoarning/checklistTareas/actions";
import SidebarConfig from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import ProgressIndicator from "../../../components/ProgressIndicator";
import { getUsers } from "../../../redux/auth/actions";
import { enviarCorreo } from "../../../redux/on&offBoarning/capacitacion/actions";
import {
  getAreas,
  getCarpetas,
  getDocs,
} from "../../../redux/gestorDocumental/actions";
import config from "../../../config";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";
import SelectSearch from "../../../components/select_search/SelectSearch";
import { selectSearchTableColumns } from "./selectSearchTableColumns";
import { setSurveyOptionsForSelectOption } from "./utils/selectSearchOptions";
import { sendSurveyUserForm } from "../../../redux/survey/survey_user_form/actions";

const WorkFlowCheckList = (props) => {
  //* Effects
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [item, setItem] = useState(null);
  const [validated, setValidated] = useState(false);
  //const [rowIndex, setRowIndex] = useState(null);
  const [showSidebard, setShowSideBar] = useState(false);
  const [validatedDate, setValidateDate] = useState(false);
  const [oData, setOData] = useState([]);
  const [userSelected, setUserSelected] = useState([]);
  const [isUserValid, setIsUserValid] = useState(false);
  const [fileName, setFileName] = useState("Imagen, pdf, documento, etc.");
  const [surveyValue, setSurverValue] = useState('');
  //* Redux
  const { loadingAuth, users } = useSelector((store) => store.auth);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const {
    loaderWorkFlowBlockCheckLists,
    saveLoaderWorkFlowBlockCheckList,
    saveLoaderWorkFlowBlockCheckListPosition,
    workflowBlockCheckListsLength,
    workflowBlockCheckLists,
    formErrorsWorkflowBlockCheckList,
    errorWorkflowBlockCheckList,
  } = useSelector((store) => store.workflowBlockCheckList);
  //paginación
  const { errorCorreoOnboarding } = useSelector((store) => store.capacitacion);


  const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);
  const userN = useSelector((store) => store.auth.username);

  const { docs, loadingDocs } = useSelector((store) => store.gestorDocumental);

  const { surveyTemplates, isLoading: isLoadingSurvey, error: surveyTemplateError } = useSelector(state => state.surveyTemplate);
  const { sendSurveyFormFaild, isSendSurveyForm } = useSelector(state => state.surveyUserForm);
  const surveySelectOptions = setSurveyOptionsForSelectOption(surveyTemplates);
  const { tipoDocumento } = config.gestorDocumental.onboarding;

  const { email } = config.gestorDocumental;

  //* Variables
  {
    /*workflowBlockCheckLists.sort((a, b) => {
    return a.posicion - b.posicion;
  });*/
  }

  let usersOptions = [];
  users.map((user) => {
    usersOptions = [
      ...usersOptions,
      {
        id: user.id,
        label: `${user.username}-${user.first_name} ${user.last_name}`,
      },
    ];
  });

  const dispatch = useDispatch();
  const { goBack } = useHistory();
  // const columns = [
  //   {
  //     Header: 'Nombre',
  //     accessor: 'nombre'
  //   },
  //   {
  //     Header: 'Fecha de inicio',
  //     Filter: '',
  //     Cell: value => moment(value.row.original.fecha_inicio).format('DD/MM/YYYY')
  //   },
  //   {
  //     Header: 'Fecha de fin',
  //     Filter: '',
  //     Cell: value => <div style={{width: '8.9rem'}} className={`rounded-pill text-white text-center px-2 ${moment() > moment(value.row.original.fecha_fin) ? 'bg-danger': moment(value.row.original.fecha_fin).diff(moment(), 'days') > 1 ? 'bg-info' : 'bg-success'}`}>{moment(value.row.original.fecha_fin).format('D MMMM, YYYY')}</div>
  //   },
  //   {
  //     Header: 'Estado',
  //     Filter: '',
  //     Cell: value => (<div className="d-flex justify-content-between"><div className={`rounded-pill ${value.row.original.estado ? 'bg-primary' : 'bg-danger'}`} style={{width: '3rem', height: '1rem', marginRight: '.6rem'}}></div><Form.Check disabled inline checked={value.row.original.estado}  /></div>)
  //   },
  //   {
  //     id: 'customButtons',
  //     Filter: '',
  //     Cell: value => (<div
  //       className="btn-group"
  //       role="group">
  //       <Button
  //         size="sm"
  //         variant="link"
  //         type="button"
  //         onClick={() => handleEditWorkFlow(value.row.original, value.row.index)}>
  //           <i className="material-icons">edit</i>
  //       </Button>
  //       <Button
  //         size="sm"
  //         className="text-danger"
  //         variant="link"
  //         type="button"
  //         onClick={() => handleDeleteWorkFlow(value.row.original.id, value.row.index)}>
  //         <i className="material-icons">close</i>
  //       </Button>
  //       {
  //         value.row.original.archivos_local && (
  //           <a
  //             target='_blank'
  //             href={`${process.env.REACT_APP_URL}/media/${value.row.original.archivos_local}`}
  //             className="btn btn-default btn-sm text-muted">
  //               <i className="material-icons">plagiarism</i>
  //           </a>
  //         )
  //       }
  //     </div>)
  //   }
  // ];

  //* Methods
  useEffect(() => {
    let filters = {}
    if (userRoles.includes("Responsable_OffBoarding") || userRoles.includes("Responsable_OnBoarding"))
      filters.usuario_x_empresa = "si"
    dispatch(getUsers(filters));
  }, [userRoles]);

  useEffect(() => {
    dispatch(
      getWorkflowBlockCheckLists(
        {
          id_bloque: props.match.params.workflowblockid,
        },
        setOData,
        parseInt(props.match.params.type)
      )
    );
  }, [dispatch, props.match.params.workflowblockid, props.match.params.type]);


  useEffect(() => {
    dispatch(getSurveyTemplates({
      offset: 0,
      limit: 20,
      filter: '',
    }));
  }, [dispatch]);


  useEffect(() => {
    if (userN !== "") {
      dispatch(
        getDocs({
          id_empleado: parseInt(userId),
          tipo_documento: tipoDocumento,
        })
      );
      dispatch(getAreas());
      dispatch(getCarpetas());
    }
  }, [props.match.params.id, userN, userId]);

  // useEffect(() => {
  //   setOData(workflowBlockCheckLists);
  // }, [workflowBlockCheckLists]);

  const handleCreateWorkFlow = () => {
    setEdit(false);
    setItem(null);
    setShow(true);
    setValidated(false);
  };

  const handleEditWorkFlow = (item, rowIndx) => {
    setEdit(true);
    setItem(item);
    setSurverValue(item?.encuesta_evaluacion || '');
    if (item.archivo_bajar !== "" || item.archivo_bajar !== null) {
      setFileName(item.archivo_bajar);
    } else {
      setFileName("Imagen, pdf, documento, etc.");
    }
    setShow(true);
    setUserSelected(
      item &&
        item.datos_compa_guia &&
        item.datos_compa_guia[0] &&
        item.datos_compa_guia[0].id
        ? [
          {
            id: item.datos_compa_guia[0].id,
            label: `${item.datos_compa_guia[0].username} - ${item.datos_compa_guia[0].first_name} ${item.datos_compa_guia[0].last_name}`,
          },
        ]
        : []
    );
    setValidated(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //const maxFileSizeKB = 29696; 
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    
    /* if (e.target.ckarchivos_local?.files?.[0] && e.target.ckarchivos_local.files[0].size > maxFileSizeKB * 1024) {
      toastr.error(`El archivo no puede superar los ${maxFileSizeKB / 1024} MB`);
      return;
    } */

    if (parseInt(props.match.params.type) === 1) {
      if (moment(e.target.ckdatest.value) > moment(e.target.ckdatef.value)) {
        setValidated(false);
        setValidateDate(true);
        return;
      } else {
        setValidated(true);
        setValidateDate(false);
      }

      const req = new FormData();
      req.append("nombre", e.target.cknombre.value);
      req.append("descripcion", e.target.ckdesc.value);
      req.append("encuesta_evaluacion", e.target.survey.value);
      req.append(
        "fecha_inicio",
        moment(e.target.ckdatest.value).format("YYYY-MM-DD")
      );
      req.append(
        "fecha_fin",
        moment(e.target.ckdatef.value).format("YYYY-MM-DD")
      );
      req.append("evaluable", e.target.ckvaluable.checked);
      req.append("calificacion", 0);

      if (e.target.ckarchivos_bajar.files.length > 0) {
        req.append("archivo_bajar", e.target.ckarchivos_bajar.files[0]);
      }
      //req.append('archivos_local', e.target.ckarchivos_local.files.length > 0 ? e.target.ckarchivos_local.files[0]: null);
      req.append("estado", false);
      req.append("subir_archivo", e.target.cksubir_archivo.checked);
      req.append("bloque", parseInt(props.match.params.workflowblockid));
      if (edit) {
        req.append("posicion", item.posicion);
        dispatch(
          editWorkflowBlockCheckList(
            req,
            item.id,
            {
              data: oData,
              setData: setOData,
            },
            parseInt(props.match.params.type),
            null,
            null,
            null,
            null
          )
        );
      } else {
        req.append("posicion", workflowBlockCheckListsLength + 1);
        dispatch(
          saveWorkflowBlockCheckList(
            req,
            {
              data: oData,
              setData: setOData,
            },
            parseInt(props.match.params.type)
          )
        );
      }
    } else {
      const req = new FormData();
      var sameComp = false;

      if (
        userSelected &&
        userSelected[0] &&
        userSelected[0].id &&
        item.compa_guia === userSelected[0].id
      ) {
        sameComp = true;
      }

      if (item.compa_guia === null && userSelected.length === 0) {
        sameComp = true;
      }

      req.append("id", item.id);
      req.append("descripcion", item.descripcion);
      req.append("estado", item.estado);
      req.append("evaluable", item.evaluable);
      req.append("subir_archivo", e.target.cksubir_archivo.checked);
      req.append(
        "fecha_inicio",
        moment(e.target.ckdatest.value).format("YYYY-MM-DD")
      );
      req.append(
        "fecha_fin",
        moment(e.target.ckdatef.value).format("YYYY-MM-DD")
      );
      if (item.evaluable) {
        req.append(
          "calificacion",
          e.target.calificacion.value || e.target.calificacion.value !== ""
            ? parseFloat(e.target.calificacion.value)
            : ""
        );
      }
      req.append("enlace_evaluacion", e.target.enlace.value);
      if (fileName === "Imagen, pdf, documento, etc.") {
        req.append("archivo_bajar", "");
      } else {
        if (e.target.ckarchivos_local.files.length > 0) {
          req.append("archivo_bajar", e.target.ckarchivos_local.files[0]);
        }
      }
      req.append("posicion", item.posicion);
      req.append("bloque", item.bloque);
      if (userSelected.length > 0) {
        req.append(
          "compa_guia",
          userSelected && userSelected[0] && userSelected[0].id
            ? userSelected[0].id
            : null
        );
      }
      dispatch(
        editWorkflowBlockCheckList(
          req,
          item.id,
          {
            data: oData,
            setData: setOData,
          },
          parseInt(props.match.params.type),
          parseInt(props.match.params.workflowid),
          parseInt(props.match.params.workflowblockid),
          parseInt(item.id),
          sameComp
        )
      );
    }
    setShow(false);
  };

  const handleDeleteWorkFlow = (id) => {
    if (window.confirm("¿Estás seguro de querer eliminar este registro?")) {
      dispatch(
        deleteWorkflowBlockCheckList(
          id,
          {
            data: oData,
            setData: setOData,
          },
          parseInt(props.match.params.type)
        )
      );
    }
  };

  const handleSaveCheckListPosition = () => {
    if (oData.length > 0) {
      let data = { primero: [] };
      oData.map((item, index) => {
        data.primero = [...data.primero, { id: item.id, posicion: index + 1 }];
      });

      dispatch(
        saveWorkFlowBlockCheckListPosition(
          data,
          { id_bloque: props.match.params.workflowblockid },
          setOData,
          parseInt(props.match.params.type)
        )
      );
    }
  };

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    const value = JSON.parse(checkValue);
    const sigIndex = value.index + 1;
    if (checked) {
      if (
        (value.evaluable &&
          value.calificacion &&
          parseFloat(value.calificacion).toFixed(2) >
          parseFloat(80).toFixed(2)) ||
        (value.evaluable &&
          value.subir_archivo &&
          value.archivos_gestor !== null &&
          !value.estado) ||
        (value.evaluable && !value.subir_archivo && !value.estado)
      ) {
        dispatch(
          estadoActividad(
            {
              tarea: parseInt(value.id),
            },
            parseInt(value.index)
          )
        );
        if (oData[sigIndex]) {
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(props.match.params.workflowid),
              bloque_id: parseInt(props.match.params.workflowblockid),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Jefe - Retraso en Tareas",
            })
          );
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(props.match.params.workflowid),
              bloque_id: parseInt(props.match.params.workflowblockid),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Responsable - Nota Evaluacion",
            })
          );
        }
      } else if (
        !value.evaluable &&
        ((value.subir_archivo &&
          value.archivos_gestor !== null &&
          !value.estado) ||
          (!value.subir_archivo && !value.estado))
      ) {
        dispatch(
          estadoActividad(
            {
              tarea: parseInt(value.id),
            },
            parseInt(value.index)
          )
        );
        if (oData[sigIndex]) {
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(props.match.params.workflowid),
              bloque_id: parseInt(props.match.params.workflowblockid),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Jefe - Retraso en Tareas",
            })
          );
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(props.match.params.workflowid),
              bloque_id: parseInt(props.match.params.workflowblockid),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Responsable - Nota Evaluacion",
            })
          );
        }
      } else {
        if (userRoles.includes("administrador")) {
          dispatch(
            estadoActividad(
              {
                tarea_id: parseInt(value.id),
              },
              parseInt(value.index),
              2
            )
          );
        } else {
          toastr.info("La tarea no puede ser actualizada");
        }
      }
    } else {
      if (
        userRoles.length > 0 &&
        (userRoles.includes("administrador") ||
          userRoles.includes("Responsable_OnBoarding") ||
          userRoles.includes("Responsable_OffBoarding"))
      ) {
        dispatch(
          estadoActividad(
            {
              tarea_id: parseInt(value.id),
              estado: "False",
            },
            parseInt(value.index),
            3
          )
        );
      }
    }
  };

  const onShowSidebar = () => setShowSideBar(showSidebard ? false : true);
  const handleClose = () => setShow(false);

  const handleAddUser = (survey) => {
    setSurverValue(survey.id);
    dispatch(onAddSurveyTemplate(survey, setItem));
  }

  const getSurveyOptions = () => {

    if (item && item.survey) {
      const exist = surveySelectOptions?.some(option => option.value === item.survey.id);
      if (!exist) {
        return [...surveySelectOptions, { value: item.survey.id, label: item.survey.name }];
      }
    }
    return surveySelectOptions;
  }

  const sendEvaluations = (tarea_id, survey_id) => {
    if (!survey_id) {
      toastr.error('No se ha seleccionado una evaluación para esta actividad');
      return;
    }
    dispatch(sendSurveyUserForm({
      tarea_id: tarea_id,
      survey_url: `${process.env.REACT_APP_SURVEY_URL}/encuestas/${survey_id}/formulario`,
    }));
  }

  return (
    <div className="p-lg-2 p-md-2">
      <CustomNavbar />
      {parseInt(props.match.params.type) === 1 ? (
        <SidebarConfig show={showSidebard} onShowSidebar={onShowSidebar} />
      ) : (
        <SidebarDashboard show={showSidebard} onShowSidebar={onShowSidebar} />
      )}
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="mb-4">

            <div className="d-flex justify-content-start align-items-center">
              <Button
                onClick={() => goBack(-1)}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i
                  className="material-icons"
                  style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                >
                  folder
                </i>{" "}
                {props.match.params.workflowblockname}
              </h4>
            </div>
            <hr />
          </div>
          {parseInt(props.match.params.type) === 2 && (
            <Row
              className="mb-2 mx-0 py-2 bg-light rounded"
              style={{ borderLeft: "6px solid #141E30 " }}
            >
              <Col>
                <p>
                  <b>
                    En caso que la actividad sea evaluable, esta debe ser mayor
                    a 80% para poder cambiar el estado.
                  </b>
                </p>
              </Col>
            </Row>
          )}
          <Row className="justify-content-start align-items-center flex-nowrap">
            <Col xs="auto" className="px-1">
              <h4 className="m-0 ml-3">
                {parseInt(props.match.params.type) === 1
                  ? "Plantillas actividades"
                  : "Actividades de tarea"}{" "}
                <i className="material-icons">star</i>
              </h4>
            </Col>
            {parseInt(props.match.params.type) === 1 && (
              <Col xs="auto" className="px-1">
                <Button
                  onClick={handleCreateWorkFlow}
                  variant="primary"
                  className="btn btn-sm rounded-pill font-weight-bold mr-2"
                >
                  <i className="material-icons">add</i> Crear nueva actividad
                </Button>
                <Button
                  onClick={handleSaveCheckListPosition}
                  variant="primary"
                  className="btn btn-sm rounded-pill font-weight-bold"
                >
                  <i className="material-icons">save</i> Guardar
                </Button>
              </Col>
            )}
          </Row>
          {!!errorWorkflowBlockCheckList && (
            <Alert variant="danger" className="mt-4 mb-1">
              {errorWorkflowBlockCheckList}
            </Alert>
          )}

          {sendSurveyFormFaild && (
            <Alert variant="danger" className="mt-4 mb-1">
              {sendSurveyFormFaild}
            </Alert>
          )}

          <Card className="border-0 mt-2">
            <Card.Body className="px-0">
              {loaderWorkFlowBlockCheckLists ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : workflowBlockCheckLists.length > 0 ? (
                // <>
                //   <CustomTable
                //     columns={columns}
                //     data={workflowBlockCheckLists} />
                // </>
                <Table responsive="sm" striped>
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Fecha de inicio</th>
                      <th>Fecha de fin</th>
                      {parseInt(props.match.params.type) === 1 ? null : (
                        <th>Calificación</th>
                      )}
                      {parseInt(props.match.params.type) === 1 ? null : (
                        <th>Estado</th>
                      )}
                      {parseInt(props.match.params.type) === 1 ? null : (
                        <th>Responsable de la actividad</th>
                      )}
                      <th></th>
                    </tr>
                  </thead>
                  {parseInt(props.match.params.type) === 1 ? (
                    <ReactSortable tag="tbody" list={oData} setList={setOData}>
                      {oData.map((item, index) => (
                        <tr key={item.id}>
                          <td className="d-flex align-items-center">
                            <i className="material-icons drag-row-react-sortable-indicator mr-3">
                              drag_indicator
                            </i>{" "}
                            {item.nombre}
                          </td>
                          <td>
                            {moment(item.fecha_inicio).format("DD/MM/YYYY")}
                          </td>
                          <td>
                            <div
                              style={{ width: "8.9rem" }}
                              className={`rounded-pill text-white text-center px-2 ${moment(moment().format("YYYY-MM-DD")).diff(
                                moment(item.fecha_fin),
                                "days"
                              ) > 0
                                ? "bg-danger"
                                : moment(item.fecha_fin).diff(
                                  moment(moment().format("YYYY-MM-DD")),
                                  "days"
                                ) === 1
                                  ? "bg-info"
                                  : "bg-success"
                                }`}
                            >
                              {moment(item.fecha_fin).format("DD/MM/YYYY")}
                            </div>
                          </td>
                          <td>
                            <div className="btn-group" role="group">
                              <Button
                                size="sm"
                                variant="link"
                                type="button"
                                onClick={() => handleEditWorkFlow(item, index)}
                              >
                                <i className="material-icons">edit</i>
                              </Button>
                              <Button
                                size="sm"
                                className="text-danger"
                                variant="link"
                                type="button"
                                onClick={() =>
                                  handleDeleteWorkFlow(item.id, index)
                                }
                              >
                                <i className="material-icons">close</i>
                              </Button>
                              {item.archivo_bajar && (
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={`${process.env.REACT_APP_URL}/media/${item.archivo_bajar}`}
                                  className="btn btn-default btn-sm text-muted"
                                >
                                  <i className="material-icons">plagiarism</i>
                                </a>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </ReactSortable>
                  ) : (
                    oData.map((item, index) => (
                      <tr key={item.id}>
                        <td className="d-flex align-items-center">
                          {item.nombre}
                        </td>
                        <td>
                          {moment(item.fecha_inicio).format("DD/MM/YYYY")}
                        </td>
                        <td>
                          <div
                            style={{ width: "8.9rem" }}
                            className={`rounded-pill text-white text-center px-2 ${moment(moment().format("YYYY-MM-DD")).diff(
                              moment(item.fecha_fin),
                              "days"
                            ) > 0
                              ? "bg-danger"
                              : moment(item.fecha_fin).diff(
                                moment(moment().format("YYYY-MM-DD")),
                                "days"
                              ) === 1
                                ? "bg-info"
                                : "bg-success"
                              }`}
                          >
                            {moment(item.fecha_fin).format("DD/MM/YYYY")}
                          </div>
                        </td>
                        <td>
                          {item.evaluable && item.calificacion
                            ? parseFloat(item.calificacion).toFixed(2) + "%"
                            : null}
                        </td>
                        <td>
                          <div className="d-flex justify-content-between">
                            <div
                              className={`rounded-pill ${item.estado ? "bg-success" : "bg-danger"
                                }`}
                              style={{
                                width: "3rem",
                                height: "1rem",
                                marginRight: ".6rem",
                              }}
                            ></div>
                            <Form.Check
                              inline
                              value={JSON.stringify({
                                id: item.id,
                                index: index,
                                evaluable: item.evaluable,
                                calificacion: item.calificacion,
                                subir_archivo: item.subir_archivo,
                                archivos_gestor: item.archivos_gestor,
                              })}
                              disabled={
                                userRoles.length > 0 &&
                                !(
                                  userRoles.includes("administrador") ||
                                  userRoles.includes(
                                    "Responsable_OnBoarding"
                                  ) ||
                                  userRoles.includes("Responsable_OffBoarding")
                                ) &&
                                ((item.evaluable &&
                                  item.calificacion &&
                                  parseFloat(item.calificacion) < 80 &&
                                  !userRoles.includes("administrador")) ||
                                  (item.subir_archivo &&
                                    item.archivos_gestor === null &&
                                    !userRoles.includes("administrador")) ||
                                  item.estado ||
                                  (userRoles.includes("jefe") &&
                                    !(
                                      userRoles.includes("administrador") ||
                                      userRoles.includes(
                                        "Responsable_OnBoarding"
                                      ) ||
                                      userRoles.includes(
                                        "Responsable_OffBoarding"
                                      )
                                    )))
                              }
                              onChange={handleCheckbox}
                              checked={item.estado ? true : null}
                            />
                          </div>
                        </td>
                        <td>
                          {item.datos_compa_guia.length > 0
                            ? `${item.datos_compa_guia[0].first_name} ${item.datos_compa_guia[0].last_name}`
                            : null}
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            {(userRoles.includes("Responsable_OnBoarding") ||
                              userRoles.includes("Responsable_OffBoarding") ||
                              userRoles.includes("administrador")) && (
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip {...props}>Editar actividad</Tooltip>
                                  }
                                >
                                  <Button
                                    size="sm"
                                    variant="link"
                                    type="button"
                                    onClick={() =>
                                      handleEditWorkFlow(item, index)
                                    }
                                  >
                                    <i className="material-icons">edit</i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            {item.archivo_bajar && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip {...props}>
                                    Ver documento subido
                                  </Tooltip>
                                }
                              >
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={`${process.env.REACT_APP_URL}/media/${item.archivo_bajar}`}
                                  className="btn btn-default btn-sm text-muted"
                                >
                                  <i className="material-icons">plagiarism</i>
                                </a>
                              </OverlayTrigger>
                            )}
                            {item.archivos_gestor && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip {...props}>
                                    Ver documento subido por el colaborador
                                  </Tooltip>
                                }
                              >
                                <LinkDescargaListGD
                                  id={item.id}
                                  filters={{
                                    email: email,
                                    id: item.archivo_gestor[0].id_documento,
                                    llave: item.archivo_gestor[0].llave,
                                  }}
                                  origen={item.archivo_gestor[0].origen}
                                  icono={<i className="material-icons">file</i>}
                                  cType={item.archivo_gestor[0].contentTypeGD}
                                />
                              </OverlayTrigger>
                            )}
                            {(userRoles.includes("Responsable_OnBoarding") ||
                              userRoles.includes(
                                "Responsable_OffBoarding"
                              )) && (
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip {...props}>
                                      Enviar Notificación
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    size="sm"
                                    variant="link"
                                    type="button"
                                    disabled={item.estado}
                                    onClick={() =>
                                      dispatch(
                                        enviarCorreo({
                                          workflow_id: parseInt(
                                            props.match.params.workflowid
                                          ),
                                          bloque_id: parseInt(
                                            props.match.params.workflowblockid
                                          ),
                                          tarea_id: parseInt(item.id),
                                          tipo_mensaje:
                                            "Jefe - Retraso en Tareas",
                                        })
                                      )
                                    }
                                  >
                                    <i className="material-icons">
                                      outgoing_mail
                                    </i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            <Button
                              size="sm"
                              variant="link"
                              type="button"
                              disabled={item.empleado_baja}
                              onClick={() => sendEvaluations(item.id, item.encuesta_evaluacion)}>
                              <i className="material-icons">send</i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </Table>
              ) : (
                <Alert variant="info">
                  Aún no hay procesos registrados, comienza agregando algunos.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? `Editar Actividad ${item.nombre}` : "Crear Actividad"}
            </Modal.Title>
          </Modal.Header>
          {parseInt(props.match.params.type) === 1 ? (
            <Modal.Body>
              {formErrorsWorkflowBlockCheckList && (
                <Alert variant="danger">
                  <h6 className="font-weight-bold">
                    Hemos experimentado los suguientes errores:
                  </h6>
                  {Array.isArray(formErrorsWorkflowBlockCheckList) ? (
                    <ul className="list-unstyled">
                      {formErrorsWorkflowBlockCheckList.map((item, inx) => (
                        <li key={inx}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    formErrorsWorkflowBlockCheckList
                  )}
                </Alert>
              )}
              {
                surveyTemplateError && (
                  <Alert variant="danger">
                    {surveyTemplateError}
                  </Alert>
                )
              }
              {edit &&
                moment(moment().format("YYYY-MM-DD")).diff(
                  moment(item.fecha_fin),
                  "days"
                ) > 0 ? (
                <Alert variant="danger">
                  <p className="m-0">
                    <i className="material-icons text-danger">warning</i> ¡La
                    tarea está atrasada!
                  </p>
                </Alert>
              ) : null}
              {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 1 ? (
                <Alert variant="info">
                  <p className="m-0">
                    <i className="material-icons text-info">info</i> ¡La tarea
                    está a punto de expirar!
                  </p>
                </Alert>
              ) : null}
              {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 0 ? (
                <Alert variant="info">
                  <p className="m-0">
                    <i className="material-icons text-info">info</i> ¡La tarea
                    expira hoy!
                  </p>
                </Alert>
              ) : null}
              <Form.Group className="mb-3">
                <Form.Label className="ml-2">Nombre</Form.Label>
                <Form.Control
                  className="rounded-pill"
                  id="cknombre"
                  name="cknombre"
                  type="text"
                  placeholder="Nombre"
                  required
                  defaultValue={item ? item.nombre : null}
                />
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="ml-2">Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  id="ckdesc"
                  name="ckdesc"
                  type="text"
                  placeholder="Descripción"
                  required
                  defaultValue={item ? item.descripcion : null}
                />
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                <Form.Control
                  className={`rounded-pill ${validatedDate ? "is-invalid" : null
                    }`}
                  id="ckdatest"
                  name="ckdatest"
                  type="date"
                  placeholder="Fecha de inicio"
                  required
                  defaultValue={item ? item.fecha_inicio : null}
                />
                <Form.Control.Feedback type="invalid">
                  <ul className="list-unstyled">
                    <li>**Campo requerido</li>
                    <li>
                      **La fecha de inicio no puede ser mayor que la fecha de
                      fin.
                    </li>
                  </ul>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="ml-2">Fecha de fin</Form.Label>
                <Form.Control
                  className={`rounded-pill ${validatedDate ? "is-invalid" : null
                    }`}
                  id="ckdatef"
                  name="ckdatef"
                  type="date"
                  placeholder="Fecha de fin"
                  required
                  defaultValue={item ? item.fecha_fin : null}
                />
                <Form.Control.Feedback type="invalid">
                  <ul className="list-unstyled">
                    <li>**Campo requerido</li>
                    <li>
                      **La fecha de fin no puede ser menor que la fecha de
                      inicio.
                    </li>
                  </ul>
                </Form.Control.Feedback>
              </Form.Group>
              <SelectSearch
                endpoint="/api/app/Survey/"
                searchColumns={selectSearchTableColumns}
                isLoading={isLoadingSurvey && loaderWorkFlowBlockCheckLists}
                options={getSurveyOptions()}
                labelName="Evaluación"
                id="survey"
                name="survey"
                addOption={(survey) => handleAddUser(survey)}
                required={false}
                isFormik={false}
                value={surveyValue}
                setValue={setSurverValue}
              //values={values}
              //handleChange={handleChange}
              //error={touched.user && errors.user ? errors.user : null}
              />
              <Form.Group className="mb-3 pl-2" controlId="ckvaluable">
                <Form.Check
                  type="checkbox"
                  defaultChecked={item ? item.evaluable : false}
                  name="ckvaluable"
                  id="ckvaluable"
                  label="Evaluable"
                />
                <Form.Check
                  type="checkbox"
                  defaultChecked={item ? item.subir_archivo : false}
                  name="cksubir_archivo"
                  id="cksubir_archivo"
                  label="Subir archivos"
                />
              </Form.Group>
              <Form.Group className="pl-2 mb-3">
                <Form.File
                  className="position-relative"
                  name="ckarchivos_bajar"
                  label="Archivo"
                  id="ckarchivos_bajar"
                />
              </Form.Group>
              {edit && item.archivo_bajar ? (
                <a
                  className="ml-2"
                  rel="noreferrer"
                  target="_blank"
                  href={`${process.env.REACT_APP_URL}/media/${item.archivo_bajar}`}
                >
                  Archivo actual
                </a>
              ) : null}
            </Modal.Body>
          ) : (
            <Modal.Body>
              {formErrorsWorkflowBlockCheckList && (
                <Alert variant="danger">
                  <h6 className="font-weight-bold">
                    Hemos experimentado los suguientes errores:
                  </h6>
                  {Array.isArray(formErrorsWorkflowBlockCheckList) ? (
                    <ul className="list-unstyled">
                      {formErrorsWorkflowBlockCheckList.map((item, inx) => (
                        <li key={inx}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    formErrorsWorkflowBlockCheckList
                  )}
                </Alert>
              )}
              {!!errorCorreoOnboarding && (
                <Alert variant="danger">
                  <p className="m-0">
                    <i className="material-icons text-danger">warning</i>
                    {errorCorreoOnboarding && errorCorreoOnboarding.mensaje
                      ? errorCorreoOnboarding.mensaje
                      : errorCorreoOnboarding}
                  </p>
                </Alert>
              )}
              {edit &&
                moment(moment().format("YYYY-MM-DD")).diff(
                  moment(item.fecha_fin),
                  "days"
                ) > 0 ? (
                <Alert variant="danger">
                  <p className="m-0">
                    <i className="material-icons text-danger">warning</i> ¡La
                    tarea está atrasada!
                  </p>
                </Alert>
              ) : null}
              {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 1 ? (
                <Alert variant="info">
                  <p className="m-0">
                    <i className="material-icons text-info">info</i> ¡La tarea
                    está a punto de expirar!
                  </p>
                </Alert>
              ) : null}
              {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 0 ? (
                <Alert variant="info">
                  <p className="m-0">
                    <i className="material-icons text-info">info</i> ¡La tarea
                    expira hoy!
                  </p>
                </Alert>
              ) : null}
              <Form.Group className="mb-3">
                <Form.Label className="ml-2">Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  id="ckdesc"
                  name="ckdesc"
                  type="text"
                  placeholder="Descripción"
                  disabled
                  readOnly
                  required
                  defaultValue={item ? item.descripcion : null}
                />
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Row className="align-items-end mb-3">
                <Col sm={loadingAuth ? 10 : 12}>
                  <Form.Label className="ml-1">
                    Responsable de la actividad
                  </Form.Label>
                  <Typeahead
                    isInvalid={isUserValid}
                    placeholder="Responsable de la actividad"
                    options={usersOptions}
                    onChange={(selected) => setUserSelected(selected)}
                    selected={userSelected}
                  ></Typeahead>
                </Col>
                {loadingAuth && (
                  <Col sm={1}>
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
              {/* {isUserValid && (
                <small className="text-danger">**Campo requerido</small>
              )} */}
              {item && item.evaluable && (
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label className="ml-1" sm="12" md="3">
                      Calificación:
                    </Form.Label>
                    <Form.Control
                      id="calificacion"
                      name="calificacion"
                      className="rounded-pill"
                      // required
                      type="number"
                      defaultValue={
                        item && item.calificacion
                          ? parseFloat(item.calificacion)
                          : null
                      }
                      placeholder="0.00"
                      pattern="[0-9]+([\.,][0-9]+)?"
                      step="0.01"
                      min="0"
                      max="100"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **El valor del campo debe estar dentro del rango 0 - 100
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              )}
              <Row>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label className="ml-1" sm="12" md="3">
                    Enlace clima laboral:
                  </Form.Label>
                  <Form.Control
                    name="enlace"
                    className="rounded-pill"
                    // required
                    type="text"
                    defaultValue={
                      item &&
                        item.enlace_evaluacion &&
                        item.enlace_evaluacion !== "null"
                        ? item.enlace_evaluacion
                        : ""
                    }
                    placeholder="Enlace clima laboral"
                  ></Form.Control>
                  {/* <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback> */}
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                  <Form.Control
                    className={`rounded-pill ${validatedDate ? "is-invalid" : null
                      }`}
                    id="ckdatest"
                    name="ckdatest"
                    type="date"
                    placeholder="Fecha de inicio"
                    required
                    defaultValue={item ? item.fecha_inicio : null}
                  />
                  <Form.Control.Feedback type="invalid">
                    <ul className="list-unstyled">
                      <li>**Campo requerido</li>
                      <li>
                        **La fecha de inicio no puede ser mayor que la fecha de
                        fin.
                      </li>
                    </ul>
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label className="ml-2">Fecha de fin</Form.Label>
                  <Form.Control
                    className={`rounded-pill ${validatedDate ? "is-invalid" : null
                      }`}
                    id="ckdatef"
                    name="ckdatef"
                    type="date"
                    placeholder="Fecha de fin"
                    required
                    defaultValue={item ? item.fecha_fin : null}
                  />
                  <Form.Control.Feedback type="invalid">
                    <ul className="list-unstyled">
                      <li>**Campo requerido</li>
                      <li>
                        **La fecha de fin no puede ser menor que la fecha de
                        inicio.
                      </li>
                    </ul>
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Col md="4">
                  <OverlayTrigger
                    placement="auto"
                    overlay={
                      <Tooltip style={{ zIndex: 999999999999 }} {...props}>
                        Habilita si el empleado puede subir archivos o no
                      </Tooltip>
                    }
                  >
                    <Form.Check
                      type="checkbox"
                      defaultChecked={item ? item.subir_archivo : false}
                      className="mx-1"
                      name="cksubir_archivo"
                      id="cksubir_archivo"
                      label="Subir archivos"
                    />
                  </OverlayTrigger>
                </Col>
              </Row>
              <Row>
                <Form.Group as={Col} className="py-2 px-3 mb-3">
                  <Form.Label className="ml-1" sm="12" md="3">
                    Archivo para descargar:
                  </Form.Label>
                  <Form.File
                    className="position-relative shadow-sm"
                    name="ckarchivos_local"
                    label="Archivo para descargar:"
                    id="ckarchivos_local"
                    defaultValue={null}
                    custom
                    style={{ fontWeight: "bold" }}
                    onChange={(e) =>
                      e.target.files && e.target.files[0].name
                        ? setFileName(e.target.files[0].name)
                        : null
                    }
                  />
                  <h6
                    className="p-2 mt-2 shadow-sm rounded"
                    style={{
                      border: "1px solid #ced4da",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item && fileName !== item.archivo_bajar
                      ? fileName
                      : "Imagen, pdf, documento, etc."}
                  </h6>
                </Form.Group>
              </Row>
              {item && item.subir_archivo && item.archivos_gestor && (
                <Row>
                  <Col className="px-3 ml-1 mb-3">
                    <h6 className="text-muted ml-3">
                      Ver documento subido por el colaborador:
                    </h6>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip
                          style={{ zIndex: 999999999999, maxWidth: "500px" }}
                          {...props}
                        >
                          Ver documento subido por el colaborador
                        </Tooltip>
                      }
                    >
                      <>
                        <ul className="list-unstyled">
                          <LinkDescargaGD
                            id={item.id}
                            filters={{
                              email: email,
                              id: item.archivo_gestor[0].id_documento,
                              llave: item.archivo_gestor[0].llave,
                            }}
                            origen={item.archivo_gestor[0].origen}
                            cType={item.archivo_gestor[0].contentTypeGD}
                          />
                        </ul>
                      </>
                    </OverlayTrigger>
                  </Col>
                </Row>
              )}
            </Modal.Body>
          )}
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={
                saveLoaderWorkFlowBlockCheckList ||
                (item && item.estado ? item.estado : false)
              }
              variant="primary"
              type="submit"
            >
              {saveLoaderWorkFlowBlockCheckList ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ProgressIndicator isLoading={saveLoaderWorkFlowBlockCheckListPosition} />
    </div>
  );
};

export default WorkFlowCheckList;
